import { render, staticRenderFns } from "./EmailFormStep.vue?vue&type=template&id=eb478610&scoped=true&"
import script from "./EmailFormStep.vue?vue&type=script&setup=true&lang=ts&"
export * from "./EmailFormStep.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./EmailFormStep.vue?vue&type=style&index=0&id=eb478610&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb478610",
  null
  
)

export default component.exports